import React, { useEffect } from "react";
import PropTypes from "prop-types";

import { setReportDataValue, mergeReportData } from "~/reports/data/actions";
import { getReportDataByReportType } from "~/reports/data/selectors";
import useReportPreferences from "~/reports/hooks/use-report-preferences";
import { useAppDispatch, useAppSelector } from "~/store/hooks";
import { ReportOptionsComponent } from ".";
import { Loader } from "~/core";

interface IReportOptionsWrapperProps {
    ReportOptions: ReportOptionsComponent<any>;
}

function ReportOptionsWrapper({ ReportOptions }: IReportOptionsWrapperProps) {
    const dispatch = useAppDispatch();
    const reportData = useAppSelector(getReportDataByReportType(ReportOptions.reportName));
    const { reportPreferences } = useReportPreferences(
        ReportOptions.reportName,
        ReportOptions.reportPreferences
    );

    // Set default reportData for this report
    useEffect(() => {
        if (reportPreferences) {
            const preferenceKeys = Object.keys(ReportOptions.defaultReportOptions);
            // Return if any of the preference keys are already set or there are no preferences
            if (
                reportData &&
                (preferenceKeys.some((key) => reportData[key] != null) ||
                    Object.keys(reportPreferences).length == 0)
            ) {
                return;
            }
            dispatch(
                mergeReportData({
                    reportType: ReportOptions.reportName,
                    reportData: {
                        ...ReportOptions.defaultReportOptions,
                        ...reportPreferences,
                    },
                })
            );
        }
    }, [reportData, reportPreferences]);

    if (!reportData || !reportPreferences) return <Loader />;

    const onInputChange = (key, value) => {
        dispatch(setReportDataValue({ reportType: ReportOptions.reportName, key, value }));
    };

    return (
        <div>
            <ReportOptions onInputChange={onInputChange} initialPreferences={reportPreferences} />
        </div>
    );
}

ReportOptionsWrapper.propTypes = {
    ReportOptions: PropTypes.elementType.isRequired,
};

export default ReportOptionsWrapper;
